<template>
  <main class="dashboard prdt-form">
    <div class="container-fluid container-fluid--max">
      <notification></notification>
      <div class="card">
        <div class="card-body">
          <router-link :to="{ name: 'productRegistrations' }" tag="a" class="back btn btn-link uppercase smaller pl-0">
            <i class="back__icon fa fa-close mr-h" aria-hidden="true"></i>Retour
          </router-link>
          <section class="dash-prdt-form px-lg-5 mt-4">
            <h1 class="dashboard__title heading-secondary mb-5">{{ title }}</h1>
            <form @submit.prevent>
              <wizard ref="prForm" @cancel="cancel" @submit="submit" :loading="loading">
                <wizard-step title="Infos">
                  <Infos :params="params" :error="errors" :edition="!creation"/>
                </wizard-step>
                <wizard-step title="Documents">
                  <div class="row" v-for="(subfiles, i) in chunkedDocuments" :key="'subfiles' + i">
                    <div class="form-group col-sm" v-for="file in subfiles" :key="file.ref">
                      <label class="access-form__label">{{ file.label}}</label>
                      <div class="custom-file">
                        <input type="file" class="custom-file-input" id="orderFile" :ref="file.ref" @change="setFile(file.ref)">
                        <label class="custom-file-label" for="orderFile" :class="{ 'border-danger': errors[file.ref] }">
                          {{ file.fileName || 'Parcourir' }}
                        </label>
                      </div>
                      <small class="text-danger">{{ errors[file.ref] }}</small>
                    </div>
                  </div>
                </wizard-step>
                <wizard-step title="Installateur">
                  <Fitter :params="params" :error="errors" />
                </wizard-step>
                <wizard-step title="Installation">
                  <Installation
                    :params="params"
                    :pictures="pictures"
                    :form-data="formData"
                    :error="errors" />
                </wizard-step>
              </wizard>
            </form>
          </section>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { mapState } from 'vuex'
import Infos from './form/Infos'
import Fitter from './form/Fitter'
import Installation from './form/Installation'

export default {
  name: 'ProductRegistrationForm',
  components: {
    Infos,
    Fitter,
    Installation
  },
  props: {
    id: {
      type: [String, Number],
      required: true
    }
  },
  data () {
    return {
      loading: false,
      formData: new FormData(),
      errors: {},
      documents: [
        { label: "Facture d'achat", ref: 'invoice_document', fileName: null },
        { label: 'Certificat de garantie', ref: 'warranty_certificate_document', fileName: null },
        { label: "Facture d'installation", ref: 'install_bill_document', fileName: null },
        { label: 'Attestation de conformité', ref: 'attestation_of_conformity_document', fileName: null },
        { label: 'Autre document', ref: 'misc_doc_1', fileName: null }
      ],
      pictures: [
        { label: 'Photo de face tubage visible jusqu’au plafond', ref: 'front', fileName: null, progress: 0, error: null, id: null },
        { label: 'Photo arrière « Te» visible', ref: 'back', fileName: null, progress: 0, error: null, id: null },
        { label: 'Photo de la sortie de fumée', ref: 'smoke_exit', fileName: null, progress: 0, error: null, id: null },
        { label: 'Photo de la prise d’air', ref: 'air_intake', fileName: null, progress: 0, error: null, id: null }
      ],
      params: {
        unknown_fitter: true,
        unknown_store: true,
        fitter_type: 'self',
        air_intake: false
      }
    }
  },
  computed: {
    ...mapState(['currentClient', 'clientAuth', 'productRegistrations', 'prFormInfos']),
    creation () {
      return this.id === 'new'
    },
    title () {
      if (this.creation) return 'Nouvel enregistrement de produit'
      else return 'Édition de l\'enregistrement de produit #' + this.id
    },
    request () {
      let url = '/clients/' + this.currentClient.id + '/product_registrations/'
      return {
        method: this.creation ? 'post' : 'put',
        url: this.creation ? url : url + this.id,
        headers: {
          ...this.clientAuth,
          'Content-Type': 'multipart/form-data'
        }
      }
    },
    chunkedDocuments () {
      return _.chunk(this.documents, 2)
    },
    moveToError () {
      let first = ['product_id', 'product_type', 'serial_number', 'store_id', 'purchased_place', 'purchased_at']
      let second = ['invoice_document', 'warranty_certificate_document', 'install_bill_document', 'attestation_of_conformity_document', 'misc_doc_1']
      let third = ['fitter_name', 'fitter_zip_code', 'fitter_city']
      if (_.intersection(_.keys(this.errors), first).length) return 0
      if (_.intersection(_.keys(this.errors), second).length) return 1
      if (_.intersection(_.keys(this.errors), third).length) return 2
      else return 3
    }
  },
  created () {
    if (!this.creation) {
      let product = _.find(this.productRegistrations, pr => pr.id === parseInt(this.id))
      this.params = _.clone(product)

      if (this.params.kind === 'bestove') {
        this.params.brand_id = 'bestove'
      }
      this.getFiles(this.documents, product.documents)
      this.getFiles(this.pictures, product.installation_pictures)
    }
  },
  methods: {
    getFiles (files, currentFiles) {
      _.map(files, file => {
        let current = currentFiles.find(f => f.name === file.ref)
        if (current) file.fileName = current.filename
        if (current && current.id) file.id = current.id
      })
    },
    setFile (ref) {
      let currentFile = _.find(this.documents, file => file.ref === ref)
      if (this.$refs[ref][0].files.length > 0) {
        currentFile.fileName = this.$refs[ref][0].files[0].name
        this.formData.append(`product_registration[${ref}]`, this.$refs[ref][0].files[0])
      } else {
        currentFile.fileName = null
        this.formData.delete(`product_registration[${ref}]`)
      }
    },
    cancel () {
      this.$router.push({ name: 'productRegistrations' })
    },
    submit () {
      this.loading = true
      if (typeof this.params.brand_id === 'number') {
        this.params.product_type = 'ForeignProduct'
      }
      for (let key in this.params) {
        let value = this.params[key]
        if (value !== null) this.formData.append(`product_registration[${key}]`, value)
      }
      this.$http({
        method: this.request.method,
        url: this.request.url,
        headers: this.request.headers,
        data: this.formData
      }).then((resp) => {
        this.$store.dispatch('fetchProductRegistrations').then(() => {
          this.loading = false
          this.$router.push({ name: 'productRegistrations' })
        })
      }).catch(err => {
        this.loading = false
        this.errors = {}
        if (err.response.status === 422) {
          let e = err.response.data
          if (e.error) {
            this.$store.dispatch('setNotification', {
              message: e.error,
              mode: 'danger'
            })
          } else {
            this.errors = _.reduce(e, (result, value, key) => {
              result[key] = value[0]
              return result
            }, {})
            this.$refs.prForm.move(this.moveToError)
          }
        }
      })
    }
  }
}
</script>
